export enum CookEscalationAction {
    TRAINING_COMPLETED = "TRANING_COMPLETED",
    FAILED = "FAILED",
    TRAINING_NOT_ATTEMPTED = "TRAINING_NOT_ATTEMPTED"
}
